var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.confirmInfo
      ? _c("div", [
          _c("form", { attrs: { "data-vv-scope": "config-sheets" } }, [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-8" }, [
                _c(
                  "div",
                  { staticClass: "box-config" },
                  [
                    _c(
                      "vs-list",
                      _vm._l(_vm.documentOptions, function(doc) {
                        return _c(
                          "vs-list-item",
                          {
                            key: doc.id,
                            staticClass: "d-block",
                            class: {
                              selected: doc.id === _vm.configDoc.configId
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex justify-content-between" },
                              [
                                _c("div", [
                                  _c("div", { staticClass: "d-flex" }, [
                                    _c("div", { staticClass: "mr-1" }, [
                                      _vm._v(" " + _vm._s(doc.value) + " ")
                                    ]),
                                    _vm.getFolio(doc)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center"
                                          },
                                          [
                                            _c("vs-icon", {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName:
                                                    "v-b-tooltip.hover.bottom",
                                                  value:
                                                    "Numeración configurada",
                                                  expression:
                                                    "'Numeración configurada'",
                                                  modifiers: {
                                                    hover: true,
                                                    bottom: true
                                                  }
                                                }
                                              ],
                                              staticClass:
                                                "mr-1 cursor-default",
                                              attrs: {
                                                icon: "check_box",
                                                color: "success"
                                              }
                                            }),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover.right",
                                                    value: "Último folio",
                                                    expression:
                                                      "'Último folio'",
                                                    modifiers: {
                                                      hover: true,
                                                      right: true
                                                    }
                                                  }
                                                ],
                                                staticClass: "cursor-default"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getLastFolio(doc)
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]),
                                  _c("small", [
                                    _c("b", [_vm._v(_vm._s(doc.label))])
                                  ])
                                ]),
                                _c("vs-button", {
                                  attrs: {
                                    color: "primary",
                                    type: "border",
                                    icon: "search"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.setConfig(doc)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-4" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.configDoc.configNombre,
                        expression: "configDoc.configNombre"
                      }
                    ],
                    staticClass: "row"
                  },
                  [
                    _c("div", { staticClass: "col-12" }, [
                      _c("h5", [
                        _vm._v(
                          " Configuración para " +
                            _vm._s(_vm.configDoc.configNombre) +
                            " "
                        )
                      ]),
                      _c(
                        "div",
                        { staticClass: "mt-3" },
                        [
                          _c(
                            "vs-select",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "w-100",
                              attrs: {
                                autocomplete: "",
                                name: "renew",
                                disabled: _vm.configDoc.referenciaId,
                                danger: _vm.errors.has("config-sheets.renew"),
                                "danger-text": _vm.errors.first(
                                  "config-sheets.renew"
                                ),
                                label: "Reiniciar configuración",
                                "data-cy": "renew"
                              },
                              model: {
                                value: _vm.configDoc.renew,
                                callback: function($$v) {
                                  _vm.$set(_vm.configDoc, "renew", $$v)
                                },
                                expression: "configDoc.renew"
                              }
                            },
                            [
                              _c("vs-select-item", {
                                attrs: {
                                  "is-selected": "true",
                                  value: "N",
                                  text: "Nunca"
                                }
                              }),
                              _c("vs-select-item", {
                                attrs: { value: "A", text: "Anual" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "mt-3" },
                        [
                          _c("vs-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              disabled: _vm.configDoc.referenciaId,
                              label: "Folio inicial",
                              maxlength: "50",
                              name: "initialSheet",
                              danger: _vm.errors.has(
                                "config-sheets.initialSheet"
                              ),
                              "danger-text": _vm.errors.first(
                                "config-sheets.initialSheet"
                              ),
                              "data-cy": "folio"
                            },
                            model: {
                              value: _vm.configDoc.initialSheet,
                              callback: function($$v) {
                                _vm.$set(_vm.configDoc, "initialSheet", $$v)
                              },
                              expression: "configDoc.initialSheet"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "mt-3" },
                        [
                          _c("vs-input", {
                            staticClass: "w-100",
                            attrs: {
                              disabled: _vm.configDoc.referenciaId,
                              label: "Prefijo",
                              maxlength: "50",
                              name: "prefix",
                              "data-cy": "prefix"
                            },
                            model: {
                              value: _vm.configDoc.prefix,
                              callback: function($$v) {
                                _vm.$set(_vm.configDoc, "prefix", $$v)
                              },
                              expression: "configDoc.prefix"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    !_vm.configDoc.referenciaId
                      ? _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            { staticClass: "mt-3 text-center" },
                            [
                              _c(
                                "vs-button",
                                {
                                  staticClass: "mt-4",
                                  attrs: {
                                    type: "border",
                                    color: "primary",
                                    size: "small"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.updateDocConfig()
                                    }
                                  }
                                },
                                [_vm._v(" Guardar ")]
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "vs-button",
                {
                  staticClass: "mt-4",
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.saveConfig()
                    }
                  }
                },
                [_vm._v(" Configurar ")]
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm.confirmInfo
      ? _c("div", [
          _c("h5", [_vm._v(" Vas a configurar la siguiente numeración: ")]),
          _c(
            "ul",
            { staticClass: "mt-3 box-config" },
            _vm._l(_vm.configSheets.configFolios, function(config) {
              return _c(
                "li",
                { key: config.configId, staticClass: "border-bottom" },
                [
                  _c("div", [
                    _c("b", [_vm._v("Documento: ")]),
                    _vm._v(_vm._s(config.configNombre) + " ")
                  ]),
                  _c("div", [
                    _c("b", [_vm._v("Folio Inicial: ")]),
                    _vm._v(_vm._s(config.folioInicial) + " ")
                  ]),
                  _c("div", [
                    _c("b", [_vm._v("Prefijo: ")]),
                    _vm._v(_vm._s(config.prefijo) + " ")
                  ]),
                  _c("div", [
                    _c("b", [_vm._v("Renovación: ")]),
                    config.renueva === "N"
                      ? _c("span", [_vm._v("Nunca")])
                      : _vm._e(),
                    config.renueva === "A"
                      ? _c("span", [_vm._v("Anual")])
                      : _vm._e()
                  ])
                ]
              )
            }),
            0
          ),
          _c("div", { staticClass: "chip-custom" }, [
            _vm._v(
              " Una vez configurada la numeración no podrá ser modificada, en caso de ser necesario deberás comunicarte con nuestra mesa de ayuda. "
            )
          ]),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "vs-button",
                {
                  staticClass: "mt-4",
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.confirmSave()
                    }
                  }
                },
                [_vm._v(" Si, configurar ")]
              ),
              _c(
                "vs-button",
                {
                  staticClass: "mt-4 ml-3",
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.cancelSave()
                    }
                  }
                },
                [_vm._v(" Cancelar ")]
              )
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }